<template>
  <div class="lista-exames">
    <div class="lista-exames-title">Resultados dos meus exames</div>
    <div class="table-responsive" v-show="hasItems">
      <b-table id="tabelaExames" hover stacked="md" :fields="fields" :items="items">
        <template v-slot:cell(exibir)="{ item }">
          <img id="visualizarExame" src="../assets/imagens/icon-visualizar.svg" alt="Visualizar exames"
            @click="displayExam(item.Dicom)" class="visualizar" title="Visualilzar exame" />
        </template>
      </b-table>
    </div>
    <b-row v-show="!hasItems">
      <div class="card-message">
        <div>
          <img src="../assets/imagens/icon-exclamation.svg" alt="Exame não foi encontrado." />
        </div>
        <div>
          <h3>
            Não foram encontrados resultados para o atendimento informado.
          </h3>
        </div>
        <div>Aguarde alguns minutos e consulte novamente.</div>
      </div>
    </b-row>
  </div>
</template>

<script>
import { generateUrlToken, getExams } from '../services/examsService';
export default {
  props: ["protocolo", "senha"],
  data() {
    return {
      hasItems: true,
      fields: [
        {
          label: "Data de realização",
          key: "DataRealizaExame",
        },
        {
          label: "Exames",
          key: "NomeExame",
        },
        {
          label: "Médico solicitante",
          key: "NomeMedicoSolicitante",
        },
        {
          label: "Médico atendente",
          key: "NomeMedicoExecutante",
        },
        {
          label: "Data liberação",
          key: "DataLiberaResultado",
        },
        {
          label: "Visualizar exame",
          key: "exibir",
        },
      ],
      items: [],
    };
  },
  methods: {
    async fetchExams() {
      try {
        this.items = await getExams(this.protocolo, this.senha);
      } catch (erro) {
        this.hasItems = false;
      }
    },
    async displayExam(dicom) {
      try {
        const urlExam = await generateUrlToken(dicom);
        window.open(urlExam, "_bank");

      } catch (erro) {
        this.hasItems = false;
      }      
    },
  },
  async mounted() {
    await this.fetchExams();    
  },
};
</script>

<style scoped>
.lista-exames {
  margin-top: 40px;
  margin: 10px;
  padding: 25px;
  background-color: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
}

.lista-exames-title {
  color: #00995d;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
}

.pagination {
  margin-top: 10px;
}

.next-page {
  color: #3dae2b;
}

.next-page /deep/ .page-link:hover {
  background: red;
}

.button-page /deep/ .page-item button {
  color: #3dae2b;
}

.button-page /deep/ .page-link:hover {
  color: #ffffff;
  background-color: #3dae2b;
}

.card-message {
  width: 440px;
  margin: 120px auto 220px;
  text-align: center;
}

.card-message div {
  margin: 15px 0;
}

.button-page /deep/ li .page-item .active .pagination {
  color: #ffffff;
  background-color: #3dae2b;
}

.visualizar {
  cursor: pointer;
}
</style>
